import React, { useEffect, useRef, useState } from 'react';
import { Tooltip } from '@mui/material';

import DialogBase from './DialogBase';
import { contentService } from '../../../services/content.service';

interface DialogBeoordelingTimelineProps {
  open: boolean;
  beoordelingen?: any;
  organisatie: string;
  onClose: () => void;
  onSubmit?: (beoordeling: any) => void;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 400,
    },
  },
};

const DialogBeoordelingTimeline: React.FC<DialogBeoordelingTimelineProps> = ({
  open,
  beoordelingen,
  organisatie,
  onClose,
  onSubmit
}) => {
  // const [currentOrganisatie, setCurrentOrganisatie] = useState(organisatie);
  // const [beoordelingStatusOptions, setStatusses] = useState<any[]>([]);

  const hasStatussesData = useRef(false);

  
  useEffect(() => {
    // Ensure the fetch happens only once
    if (!hasStatussesData.current) {
      // getBeoordelingStatusses();
      hasStatussesData.current = true; // Mark as fetched
    }
  }, []);

  // const getBeoordelingStatusses = async () => {
  //   await plannenService.getBeoordelingStatusses();
  //   const statusses = plannenService.beoordelingStatusses as any[];
  //   setStatusses(statusses);
  // };

  const sortedBeoordelingen = [...beoordelingen].sort(
    (a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
  );

  const getBeoordelingIcon = (key: string) => {
    let icon = contentService.getBeoordelingStatusIcon(key);
    return icon;
  };

  const getBeoordelingStatusLabel = (key: string) => {
    const label = contentService.getBeoordelingStatusLabel(key);
    return label;
  };

  return (
    <DialogBase
      open={open}
      title={`Beoordelingen historie${organisatie ? ` van ${organisatie}` : ''}`}
      onClose={onClose}
      width="800px"
    >
      <section>
        {sortedBeoordelingen.length > 0 ? (
          <div className="timeline-container">
            {sortedBeoordelingen.map((item: any, index: number) => (
                <div className="timeline-item" key={index}>
                  <div className="timeline-marker">
                    <Tooltip title={getBeoordelingStatusLabel(item.key.id)} 
                      placement="right" 
                      arrow>
                      <span className={`beoordeling-icon ${item.key.id}`}>
                        <span className="material-icons">{getBeoordelingIcon(item.key.id)}</span>
                      </span>
                    </Tooltip>
                  </div>

                  <div className="timeline-content">
                    <div className="beoordeling-status">
                      <strong>Status:</strong> {" "}
                      {getBeoordelingStatusLabel(item.key.id)}
                    </div>
                    <div className="beoordeling-meta">
                      {new Date(item.timestamp).toLocaleDateString('nl-NL', { day: '2-digit', month: 'short', year: 'numeric' })} - {item.user.toLowerCase()}
                    </div>
                    {item.remark && <p>{item.remark}</p> }
                  </div>
                </div>
            ))}
          </div>
        ) : (
          <p>Er zijn nog geen beoordelingen</p>
        )}

      </section>
      
    </DialogBase>
  );
};

export default DialogBeoordelingTimeline;
